import { render, staticRenderFns } from "./machineTip.vue?vue&type=template&id=04e2c1cf&scoped=true&"
import script from "./machineTip.vue?vue&type=script&lang=js&"
export * from "./machineTip.vue?vue&type=script&lang=js&"
import style0 from "./machineTip.vue?vue&type=style&index=0&id=04e2c1cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2c1cf",
  null
  
)

export default component.exports